import { ReactComponent as Organic } from "./organic.svg";
import { ReactComponent as GlutenFree } from "./gluten_free.svg";
import { ReactComponent as Vegan } from "./vegan.svg";
import { ReactComponent as Vegetarian } from "./vegetarian.svg";
import { ReactComponent as LactoseFree } from "./lactose_free.svg";
import { ReactComponent as SugarFree } from "./sugar_free.svg";

const foodCategoryIconsMap: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  "23581542-b1d8-471c-b5e3-c2bd05d8427f": Organic,
  "0437d63b-4f43-4581-b816-ec665dac1470": GlutenFree,
  "694d539a-882e-47e4-a8eb-7f0c46cdd427": Vegan,
  "74d5642b-c4b4-4749-a074-ff6326374311": Vegetarian,
  "97906d02-04c1-418c-b6da-9966848de54c": LactoseFree,
  "d38824ce-d853-48d2-acff-9c423e140c24": SugarFree,
}

export default foodCategoryIconsMap;